<template>
  <div class="ion-page">
    <ion-header-bar class="bar-positive">
      <h1 class="title">
        <span>
          <img class="title-image" src="../../assets/logo.png" height="80%" />
          Fairfield Allergy My Shot Login</span
        >
      </h1>
    </ion-header-bar>
    <ion-content class="ion-padding">
      <ion-spinner
        class="spinner"
        v-if="showSpinner"
        name="bubbles"
      ></ion-spinner>
      <ion-grid>
        <ion-row justify-content-center>
          <ion-col align-self-center size-md="6" size-lg="5" size-xs="12">
            <div padding>
              <ion-item>
                <ion-input
                  type="text"
                  :value="userName"
                  ref="theUserName"
                  name="userName"
                  id="userName"
                  placeholder="Username"
                ></ion-input>
              </ion-item>
              <ion-item>
                <ion-input
                  type="password"
                  :value="userPassword"
                  ref="theUserPassword"
                  name="userPassword"
                  id="userPassword"
                  placeholder="Password"
                ></ion-input>
              </ion-item>
            </div>
            <div padding>
              <ion-button
                size="default"
                id="patientLogin"
                class="adjust-font-size"
                @click="checkCredentials"
                expand="block"
                >Login</ion-button
              >
            </div>
            <div padding>
              <ion-button
                size="default"
                id="patientLogin"
                class="adjust-font-size"
                @click="forgotPassword"
                expand="block"
                >Forgot Password</ion-button
              >
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </div>
</template>
<script>
import Repository from "../../repositories/RepositoryFactory";
var AuthorizationRepository = Repository.get("authorization");
export default {
  name: "adminlogin",
  data() {
    return {
      info: null,
      userName: "",
      userPassword: "",
      showSpinner: false,
    };
  },
  created: async function () {
    var userid = window.location.hash.substr(1);
    if (userid.length > 0) {
      this.showSpinner = true;
      var result = await AuthorizationRepository.userIdPassword(userid);
      this.userName = result.data.uid;
      this.userPassword = result.data.pwd;
      this.showSpinner = false;
    }
  },

  methods: {
    checkCredentials: async function () {
      let self = this;
      this.userName = this.$refs.theUserName.value;
      this.userPassword = this.$refs.theUserPassword.value;
      var userLogin = {
        UserName: this.userName,
        Password: this.userPassword,
      };

      this.showSpinner = true;

      var result = await AuthorizationRepository.login(userLogin);
      if (result.data.status === "Success") {
        // eslint-disable-next-line no-console
        console.log(result);
        this.$store.state.location = result.data.location;
        this.$store.state.userName = this.userName;
        this.$store.state.email = result.data.email;
        this.$store.state.city = result.data.city;
        this.$store.state.firstName = result.data.firstName;
        this.$store.state.lastName = result.data.lastName;
        this.$store.state.dateOfBirth = result.data.dateOfBirth;
        this.$store.state.sex = result.data.sex;
        this.$store.state.homePhone = result.data.homePhone;
        this.$store.state.userId = result.data.userId;
        this.$store.state.password = this.userPassword;

        this.showSpinner = false;

        self.$router.push({
          name: "main",
          params: { data: this.$store.state.userId },
        });
      } else if (result.data.status === "Change") {
        // eslint-disable-next-line no-console
        console.log(result);
        this.$store.state.location = result.data.location;
        this.$store.state.userName = result.data.userName;
        this.$store.state.email = result.data.email;
        this.$store.state.city = result.data.city;
        this.$store.state.firstName = result.data.firstName;
        this.$store.state.lastName = result.data.lastName;
        this.$store.state.dateOfBirth = result.data.dateOfBirth;
        this.$store.state.sex = result.data.sex;
        this.$store.state.homePhone = result.data.homePhone;
        this.$store.state.userId = result.data.userId;
        this.$store.state.password = result.data.password;
        this.showSpinner = false;

        self.$router.push({
          name: "changeuser",
          params: { data: this.$store.state.userId },
        });
      } else {
        this.showSpinner = false;
        alert("Id or Password not Correct.  Please Try Again");
      }
    },
    forgotPassword: async function () {
      let self = this;
      self.$router.push({
        name: "forgotpassword",
      });
    },
  },
};
</script>
